import OrdersDB from 'src/firebase/db/Orders';

export const getMonthRevenue = ({
  shopId,
  startDate,
  endDate,
}: {
  shopId: string;
  startDate: Date;
  endDate: Date;
}) => {
  return OrdersDB.getMonthRevenue({
    shopId,
    startDate,
    endDate,
  });
};
